import { render, staticRenderFns } from "./mobile-sdkobtain.vue?vue&type=template&id=71d7d062&"
import script from "./mobile-sdkobtain.vue?vue&type=script&lang=js&"
export * from "./mobile-sdkobtain.vue?vue&type=script&lang=js&"
import style0 from "./mobile-sdkobtain.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports